import JsPDF from 'jspdf';
import * as htmlToImage from 'html-to-image';
import { Events, mobile } from '@constants';
import { IPdf, IProject } from "../interfaces";
import { changePathStroke, fitPathsToMap, getFacilityAndFloor } from "./utils";
import Emitter from "./emitter";

// Definition of instruction types (english example)
const FLOOR_CHANGE = 2; // "Proceed to floor"

// Navigation Images based on instruction types defined in spreo/navigation/instructions.js
// TODO: save these images elsewhere
const navImages: string [] = [];

// start
navImages.push("start");

// straight
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAfCAYAAADupU20AAAABmJLR0QA/wD/AP+gvaeTAAABzUlEQVQ4jZXVz4tNYRgH8M+9ZhRiwUWUzGKaUoOsNCWKnVnY4w9gxWJcOxQbZcGOhYWSH0V+DGJDUhQpRX7bsJGaWKBpalyL845573vfc+711Omcnu+P93ne9znnUB0DuI7veI/9qHfR/IsF+IBWco31arArI27hS0yqKmd5SX4Z5vRi8Lgk/wTTFbq2OKG9/K8Yjgm1CnENqzGIEXzDFUz0svI2vAirTmBfryUP4Yb87u/uJt6DqRJxC8+qxAOYrBB3nH8a5yPifXzKGLxUbOr2VLxeca6t0MIQfmUMLmM0YCMz4joOmx2oM+E+P1PlW6wJ2M2wkLripYEfOIq1JW2+UcwENHALS2ElmlgXwCOZ8luh1UHFQMVtdcS1jHga8wK+0ewe3ckZPM8YfEw4G3AQK3IGFzMG93LEsliMh5kWDvyPyVycy1RyFv3dxA2cRB8O4U9iMq76M2AsEO9iIXbqfE9Gy8Q1vIuIV0N+E35H+dNlBluTleKNG4/yn8sMLkWkSWFUQ+xNzIdTcUN7rxcSfFVi0EwNmglhS6bCVxH+IAUfReBr+aM6HnGmsCj+sTyNno8FUhq3o+d+LInBPuzA5oxwJmqKCf2JU/AXl721BSq9CuUAAAAASUVORK5CYII=");
// level change
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAABmJLR0QA/wD/AP+gvaeTAAAA8UlEQVRIidXWPUoDURQG0GMMViLWgo2FK7CxEkEQQXADug9dgYKFuIZUrsFCOxGbtAFdgSCIlfjbzIUgJnkzuVPkg68bDsPMe+8+ynJRNSV7+K56MC22gmf8VH3BalOsg+shLHqL+SbgyT9Y9LgutoH3MeAHNkuxRQzGYNEnLJWAvQIsejUJO6qBRQ9HYWt4bQC+Yf0v1sVdAyz6gIVh8GwKLHoa2BY+E8Av7HSxj/6oD1szu0nOLGUO59hO8m5I/sshp65DWtgpJO/lSOppE0k9D2nhxCZ5pkRSpx4tzGWSbw6RWnebkld/xDLucTnp4V9KdgLS7waXWQAAAABJRU5ErkJggg==");
// left
navImages.push("data:image/png;base64,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");

// right
navImages.push("data:image/png;base64,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");

// Arrive
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAkCAMAAABL02EiAAABSlBMVEUAAAD/AAD/AFXVK1XYJzvbJEnPIEDVK0fZJkDWKUfZJkLYJ0bVK0fWKUXYJ0HVJUbUJ0XVJkTWJUbTKETUJ0PVJkXWJkTVJkLWJkXTKETVJ0XVJ0XWJkXVJ0XWJ0TVKETVJ0PWJ0XVKETWJ0TVJkPVKEXWKETWKETVJ0XVJ0TWJkXWJkTUKEXVJ0XVJ0TWJkTVJ0TWJkTVKETVJ0TWJ0TVKEPVJ0TVJ0TVJkTVKETVJ0XVJ0TVJ0TWJ0TVJ0TVJkXVKETnhZbVJ0TVJ0TrnKjVJ0Phan3VJ0TVJ0ThYXbVJ0TVJ0TVJ0TtpLDWKUb42d3VJ0TWLEnVJ0TVKUXWLEjuqbTVJ0TiaH3WLUnqlqXVJ0TleYzVJ0TVJ0T20dfVJ0T54OTVKEXVJ0Twr7rVJ0TyusTyu8T209n31Nr42+D54OT88fP99fb///+JHCwBAAAAZHRSTlMAAQMGDQ4QEhQZGyEkJSc3Ozw+QEFDRElKUlVcXWhpbW5vdHWMjY6anJ2gpqerrK2vs7S3ucHCxMfIycrM0dPU1dbY2d3f4OHi6+3u8PDx8fLy8/Pz8/X19vb4+Pn6+/z8/f7+vUc0EAAAAAFiS0dEbbsGAK0AAAEXSURBVBgZbcHnQwEBHAbg94gGbdpDe9NUqEhLey9p6W1y///X8LvLreeBrnFkNpqMzgz7YRaMUxcLoMozT6NwDTS+FM2SPlR4UrRKe1GiLNNuSQHQQyfdgGubTtIutFGTv/v8/jjIU9OKcYr8u1p2k6cYRYziURV7FGvIUHyp4pliH1mKgioKFFkcUfyq4pXiEJsUD6rYotjAFMX9j1p2dkUxiT5qrk+KanHnlJpeeHPUvV28UJfzAhE6CQPooJMgACVOu3UFJV2060TFCq1WIQK0aocmQrM56OqPaXTegH9DNBpElSvBqoQLBv5L6m6bYDJAXT/MlEWKBQUWtbssy9TBpjlH8qkFDkIkQ3A0wWk4c4+5UfUH9XTmEXR6i/sAAAAASUVORK5CYII=");
// exit
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAhCAYAAADdy1suAAAABmJLR0QA/wD/AP+gvaeTAAAA+klEQVRIie3WPUrEQBgG4CeyK6w/2FutxXZewGI7r2ClnZ2FXkLBO3gDbyDbW2mfCyxoYWGjYOFYbMQYws5kTUBxXxiSwMzDMPk+kgx3OkiG0AW80gUKvdJ9jqMGawc4xiH6dRNCMe4TwXWcYVpaWzeS4c0CfIiAyfAaLvCcCCbDuw3BgNBZVSzhJfzf4BynuEldkNrS4+J5gFcttvSwuG5jtc0dv2GCp9huEXq1VH362E+d/CuqolHKRzEyO8NqNhaB/95/RSb+poe4isx5xLlZdyZn3sf0BZfYagLOg99x7asbF0oVvsXeT8AqnOOgDfAzOzjxveaj+QDYN3SQEsRt2wAAAABJRU5ErkJggg==");
// enter (should be same as exit icon)
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAhCAYAAADdy1suAAAABmJLR0QA/wD/AP+gvaeTAAAA+klEQVRIie3WPUrEQBgG4CeyK6w/2FutxXZewGI7r2ClnZ2FXkLBO3gDbyDbW2mfCyxoYWGjYOFYbMQYws5kTUBxXxiSwMzDMPk+kgx3OkiG0AW80gUKvdJ9jqMGawc4xiH6dRNCMe4TwXWcYVpaWzeS4c0CfIiAyfAaLvCcCCbDuw3BgNBZVSzhJfzf4BynuEldkNrS4+J5gFcttvSwuG5jtc0dv2GCp9huEXq1VH362E+d/CuqolHKRzEyO8NqNhaB/95/RSb+poe4isx5xLlZdyZn3sf0BZfYagLOg99x7asbF0oVvsXeT8AqnOOgDfAzOzjxveaj+QDYN3SQEsRt2wAAAABJRU5ErkJggg==");
navImages.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAhCAYAAADdy1suAAAABmJLR0QA/wD/AP+gvaeTAAAA+klEQVRIie3WPUrEQBgG4CeyK6w/2FutxXZewGI7r2ClnZ2FXkLBO3gDbyDbW2mfCyxoYWGjYOFYbMQYws5kTUBxXxiSwMzDMPk+kgx3OkiG0AW80gUKvdJ9jqMGawc4xiH6dRNCMe4TwXWcYVpaWzeS4c0CfIiAyfAaLvCcCCbDuw3BgNBZVSzhJfzf4BynuEldkNrS4+J5gFcttvSwuG5jtc0dv2GCp9huEXq1VH362E+d/CuqolHKRzEyO8NqNhaB/95/RSb+poe4isx5xLlZdyZn3sf0BZfYagLOg99x7asbF0oVvsXeT8AqnOOgDfAzOzjxveaj+QDYN3SQEsRt2wAAAABJRU5ErkJggg==");

navImages.push("data:image/png;base64,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");

class Pdf implements IPdf {
    public doc: any;

    public project: IProject;

    public gmap: any;

    public naviRequest: any;

    public simple: boolean;

    public origin: any;

    public destination: any;

    public time: string;

    public distance: number;

    public instructions: any;

    public intermediateFloors: number [];

    public paths: any;

    public routeFacilities: any;

    public floorsToPrint: number [];

    public routeCount: number;

    public pageLogo: string | ArrayBuffer | null;

    public docLang: string;

    public startingHeight: number;

    public printModalId: string;

    public navigationTabId: string;

    public path: any;

    public mozilla: boolean;

    public currentY: number;


    /**
     *
     * @param project
     * @param navigationData
     * @param simplifiedVisible
     */
    constructor(project: IProject, navigationData: any, simplifiedVisible: boolean) {
        this.project = project;
        this.gmap = navigationData.path.gmap;

        // Save parameters to request instructions in new language
        this.naviRequest = navigationData.path.naviRequest;
        this.simple = simplifiedVisible;

        // Get origin destination and other things to print
        this.origin = navigationData.path.origin;
        this.destination = navigationData.path.destination;
        this.time = navigationData.time;
        this.distance = navigationData.path.distance;
        this.instructions = simplifiedVisible ? navigationData.simplified : navigationData.instructions;

        this.doc = new JsPDF();

        this.docLang = this.project.userLang;
        if (this.docLang === 'he') {
            this.doc.addFileToVFS('Alef-Regular-normal.ttf', "hebrewFont");
            this.doc.addFont('Alef-Regular-normal.ttf', 'Alef-Regular', 'normal');
            this.doc.setR2L(true);
        }

        // Data for creating appropiate map fits to printing
        this.intermediateFloors = navigationData.path.intermediateFloors;
        this.paths = navigationData.path.paths;

        // Multiple Floors for printing options
        this.routeFacilities = navigationData.path.routeFacilities;
        this.floorsToPrint = navigationData.path.routeFloors;

        // Variable to keep track of current floor and facility to print
        // Kept in a variable so it can be printed multiple times in a row
        this.routeCount = 0;

        this.pageLogo = project.pname;
        /* if (project.pid === "anschutz_medical_campus") {
            this.getImgDataUrl("images/uch_logo.png");
        } else {
            this.getImgDataUrl("images/CenTrak-Logo.png");
        } */

        this.startingHeight = 0;
        this.printModalId = '#printModal';
        this.navigationTabId = '#find';
        this.path = navigationData.path;

        this.mozilla = window.navigator.userAgent.indexOf('Firefox') > -1;
        this.currentY = 0;
        console.error = () => null;
    }

    /**
     *
     * @param filePath
     */
    getImgDataUrl(filePath: string) {
        const request = new XMLHttpRequest();
        request.open("GET", filePath, true);
        request.responseType = "blob";
        request.onload = () => {
            const reader = new FileReader();
            reader.readAsDataURL(request.response);
            reader.onload = (e: ProgressEvent<FileReader>) => {
                const target: any = e?.target;
                this.pageLogo = target.result || null;
            };
        };
        request.send();
    }

    printDocument() {
        this.doc.autoPrint();

        const iframe: any = document.getElementById("output");
        iframe.src = this.doc.output("datauristring");
    }

    /**
     *
     * @param route
     * @param pdf
     */
    saveDocument(route: string, pdf: any) {
        const pages = this.doc.internal.getNumberOfPages();
        const pageWidth = this.doc.internal.pageSize.width;
        const pageHeight = this.doc.internal.pageSize.height;

        if (this.docLang === 'he') {
            this.doc.setFont("Alef-Regular", "normal");
        } else {
            this.doc.setFont("helvetica", "italic");
        }

        for (let j: number = 1; j < pages + 1; j++) {
            // this.doc.addImage(this.pageLogo, "JPEG", 10, 7, 45, 7);
            this.doc.setFontSize(16);
            this.doc.text(this.pageLogo, 9, 11);

            this.doc.setFontSize(12);
            if (pages > 1) {
                const horizontalPos = pageWidth - 20;
                const verticalPos = 10;
                this.doc.setPage(j);

                if (j > 1) {
                    this.doc.line(10, 18, pageWidth - 10, 18);
                }

                this.doc.text((window as any).lang.getString('pdf_pageNumText', [j, pages]), horizontalPos, verticalPos, { align: 'right' });

                if (j !== pages) {
                    this.doc.text((window as any).lang.getString('pdf_nextPageText'), (pageWidth / 2) - 10, pageHeight - 10, { align: 'center' });
                }
            }
        }

        // Add a new page to insert QR code on separate page
        if(this.currentY > (pageHeight - 60)) {
            this.doc.addPage();
        }

        const link = window.location.href.split('?')[0].split('#')[0];
        const shareUrl = `${link}?from=${pdf.origin.poid}&to=${pdf.destination.poid}&lang=${pdf.project.userLang}&pid=${pdf.project.pid}&pname=${encodeURIComponent(pdf.project.pname)}&apikey=${pdf.project.apikey}`;
        const dataUrl = new (window as any).QRious({ value: shareUrl });
        this.doc.addImage(dataUrl.toDataURL('image/jpeg'), "JPEG", (pageWidth / 2) - 25, pageHeight - 60, 50, 50);

        // instead of route we can use the following pdf.project.pname.replace(/\s+/g, '-') + '-Navigation'
        const isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i)
        if(mobile && isSamsungBrowser) {
            window.open(this.doc.output('bloburl'), '_blank');
        } else {
            this.doc.save(`${route}.pdf`);
        }
    }

    /**
     *
     * @param floor
     * @param currentHeight
     */
    imageHeader(floor: string, currentHeight: number) {
        const textAlign = this.docLang === 'he' ? 'right' : 'left';
        if (this.docLang === 'he') {
            this.doc.setFont("Alef-Regular", "normal");
        } else {
            this.doc.setFont("helvetica", "bold");
        }
        this.doc.setFontSize(11);
        this.doc.text((window as any).lang.getString('pdf_imageHeaderText', [floor]),
            (this.docLang === 'he' ? 188 : 18), currentHeight + 3, { align: textAlign });
    }

    /**
     *  Function adds all the instructions to the document.
     *  For single map, multiple maps and no maps.
     *  @param currentHeight
     *  @param stepInstructions
     *  @param instructionIndex?
     *  @param finish?
     */
    addStepInstructions(currentHeight: number, stepInstructions: any [], instructionIndex?: number, finish?: any) {
        let lineHeight = currentHeight + 5;
        const loopStart = instructionIndex || 0;
        const docHeight = this.doc.internal.pageSize.height;
        const docWidth = this.doc.internal.pageSize.width;

        for (let i = loopStart; i < stepInstructions.length; i++) {
            // Check that we are not at end of document before adding instruction
            if (lineHeight > docHeight - 20) {
                this.doc.addPage();
                lineHeight = 20;
            }

            const navigationImage = navImages[stepInstructions[i].type];

            if (this.docLang === 'he') {
                this.doc.setFont("Alef-Regular", "normal");
                this.doc.setFontSize(12);
                this.doc.line((docWidth / 2) - 15, lineHeight + 10, docWidth - 20, lineHeight + 10);

                if (stepInstructions[i].type === 1) {
                    this.doc.text((stepInstructions[i].distance > 1 ?
                        (window as any).lang.getString('nav_instructionDistM', [Math.round(stepInstructions[i].distance)]) :
                            (window as any).lang.getString('nav_instructionSmallDistM')),
                        (docWidth / 2) - 10,
                        lineHeight + 5,
                        { align: 'left' }
                    );
                }

                // Text and line between instructions
                this.doc.text(stepInstructions[i].text, 162, lineHeight + 5, { align: 'right' });

                if (navigationImage) {
                    this.doc.addImage(navigationImage, "JPEG", 172, lineHeight, (stepInstructions[i].type === 5 ? 4.5 : 4), 7);
                }

                this.doc.text(`${(i + 1)}. `, 182, lineHeight + 5, { align: 'right' });
            } else {
                this.doc.setFont("helvetica", "normal");
                this.doc.setFontSize(12);
                this.doc.text(`${(i + 1)}. `, 17, lineHeight + 5);

                // Add navigation image before text
                if (navigationImage) {
                    this.doc.addImage(navigationImage, "PNG", 23, lineHeight, (stepInstructions[i].type === 5 ? 4.5 : 4), 7);
                }

                // Text and line between instructions
                this.doc.text(stepInstructions[i].text, 30, lineHeight + 5);
                this.doc.line(17, lineHeight + 10, (docWidth / 2) + 10, lineHeight + 10);

                const feetDistance = Math.round(stepInstructions[i].distance / 0.3048);
                if (stepInstructions[i].type === 1) {
                    this.doc.text((feetDistance > 1 ? (window as any).lang.getString('nav_instructionDistFt', [feetDistance]) : (window as any).lang.getString('nav_instructionSmallDistFt')), (this.doc.internal.pageSize.width / 2) - 5, lineHeight + 5);
                }
            }

            lineHeight += 15;
            // TODO: change this to type instruction as well (the to floor doesnt work in spanish)
            if (finish === undefined && (stepInstructions[i].type === FLOOR_CHANGE ||
                (i < stepInstructions.length - 1 &&
                    stepInstructions[i].floor !== stepInstructions[i + 1].floor))) {
                return { currentHeight: lineHeight, instructionIndex: i + 1 };
            }
        }

        this.currentY = lineHeight;
        return { currentHeight: lineHeight };
    }

    /**
     *
     * @param data this is canvas object or dataUrl
     * @param imageParams
     * @param currentHeight
     * @param instructionIndex
     * @param nextFloor
     */
    addFloorImage(
        data: any,
        imageParams: any,
        currentHeight: number,
        instructionIndex: number | undefined,
        nextFloor: number
    ) {
        const imgHeight: number = 170 * imageParams.ratio;
        this.imageHeader(this.project.floorNames[nextFloor], currentHeight);
        if(!mobile && this.mozilla) {
            this.doc.addImage(data, "PNG", 18, currentHeight + 7, 170, imgHeight);
        } else {
            this.doc.addImage(data.toDataURL(), "PNG", 18, currentHeight + 7, 170, imgHeight);
        }
        currentHeight += imgHeight + 17; // add image height

        // Add Instructions after image
        const documentState = this.addStepInstructions(currentHeight, this.instructions, instructionIndex);

        // Change back path strokes (normal is 7 for now...)
        changePathStroke(this.paths[`floor${nextFloor}`], 7);

        // If there are no more instructions left then save the document.
        if (!documentState) {
            Emitter.emit(Events.GENERATE_PDF_LOADER, false);
            this.saveDocument((window as any).lang.getString('pdf_fileNameToText', [this.origin.description, this.destination.description]), this);
            return;
        }

        if (this.doc.internal.pageSize.height - documentState.currentHeight < 130) {
            this.doc.addPage();
            documentState.currentHeight = 20;
            this.currentY = 20;
        }

        Emitter.emit(Events.GENERATE_PDF_LOADER, false);
        this.printMultipleFloors(imageParams, documentState.currentHeight + 15, documentState.instructionIndex);
    }

    static hideCloseBtns() {
        const btns: any = document.querySelectorAll('.gm-ui-hover-effect');
        btns.forEach((btn: any) => {
            btn.style.display = 'none';
        });
    }

    static displayCloseBtns() {
        const btns: any = document.querySelectorAll('.gm-ui-hover-effect');
        btns.forEach((btn: any) => {
            btn.style.display = 'block';
        });
    }

    /**
     *
     * @param imageParams
     * @param currentHeight
     * @param instructionIndex
     * @param nextFloor
     */
    addFloor(imageParams: any, currentHeight: number, instructionIndex: number | undefined, nextFloor: number) {
        setTimeout(() => {
            const map: any = document.querySelector(".gm-style div");

            // Removed black square in the hint bubble in PDF
            Pdf.hideCloseBtns();

            /**
             * We should use html-to-image library only for Mozilla Firefox on PC
             * to optimize PDF generating.
             * There is an issue in Firefox with converting images from html
             * See more https://github.com/niklasvh/html2canvas/issues/2028
             */
            if(!mobile && this.mozilla) {
                htmlToImage.toPng(map)
                    .then( (dataUrl: string) => {
                        this.addFloorImage(
                            dataUrl,
                            imageParams,
                            currentHeight,
                            instructionIndex,
                            nextFloor
                        );

                        Pdf.displayCloseBtns();
                    });
            } else {
                (window as any).html2canvas(map, {
                    useCORS: true,
                    logging: false,
                    width: imageParams.width,
                    height: imageParams.height,
                })
                    .then( (canvas: any) => {
                        this.addFloorImage(
                            canvas,
                            imageParams,
                            currentHeight,
                            instructionIndex,
                            nextFloor
                        );

                        Pdf.displayCloseBtns();
                    });
            }
        }, 3000);
    }

    documentHeader() {
        const textAlign: string = this.docLang === 'he' ? 'right' : 'left';
        this.startingHeight = 24;

        if (this.project.pid === "anschutz_medical_campus") {
            // this.doc.addImage(this.pageLogo, "JPEG", 10, 10, 60, 25);
            this.startingHeight = 40;
        } else {
            if (this.docLang === 'he') {
                this.doc.setFont("Alef-Regular", "normal");
            } else {
                this.doc.setFont("helvetica", "bold");
            }

            this.doc.setR2L(false);
        }

        if (this.docLang === 'he') {
            this.doc.setR2L(true);
            this.doc.setFont("Alef-Regular", "normal");
        } else {
            this.doc.setFont("helvetica", "bold");
        }
        this.doc.setFontSize(13);

        const pathText = (window as any).lang.getString('pdf_fileNameToText', [this.origin.description, this.destination.description]);
        this.doc.text(pathText, (this.docLang === 'he' ? 190 : 10), this.startingHeight, { align: textAlign });

        this.doc.line(10, 35, this.doc.internal.pageSize.width - 10, 35);

        // Facility and floor of origin and destination
        const originInfo = getFacilityAndFloor(this.project, this.origin.facility, this.origin.floor);
        const destinationInfo = getFacilityAndFloor(this.project, this.destination.facility, this.destination.floor);
        const facilitiesText = (window as any).lang.getString(
            'pdf_facilitiesText',
            [
                originInfo.facility,
                this.project.floorNames[this.origin.floor],
                destinationInfo.facility,
                this.project.floorNames[this.destination.floor]
            ]
        );

        if (this.docLang === 'he') {
            this.doc.setFont("Alef-Regular", "normal");
        } else {
            this.doc.setFont("helvetica", "normal");
        }
        this.doc.setFontSize(12);
        this.doc.text(facilitiesText, (this.docLang === 'he' ? 190 : 10), this.startingHeight + 7, { align: textAlign });

        return this.startingHeight;
    }

    /**
     *
     * @param imageParams
     * @param currentHeight
     * @param instructionIndex
     */
    printMultipleFloors(imageParams: any, currentHeight: number, instructionIndex?: number) {
        const nextFloor: number | undefined = this.floorsToPrint[this.routeCount];
        this.routeCount += 1;

        if (nextFloor === undefined) {
            // add last instructions
            this.saveDocument((window as any).lang.getString('pdf_fileNameToText', [this.origin.description, this.destination.description]), this);
        } else {
            if (nextFloor !== this.path.navObj.currentFloor) {
                this.path.navObj.floorChange(this.path.navObj.currentFloor, nextFloor);
            }
            this.path.navObj.changeViewFloor(nextFloor);

            // Fit window closest to the paths themselves, make stroke bigger so it is more visible printing
            fitPathsToMap(this.paths[`floor${nextFloor}`], this.routeFacilities[`route${nextFloor}`]);
            changePathStroke(this.paths[`floor${nextFloor}`], 10);

            Emitter.emit(Events.GENERATE_PDF_LOADER, true);

            const checkExist = setInterval(() => {
                // if ($(".spreo-map > div > div > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > div:nth-child(2) > div > div").length > 0) {
                    if ($(".spreo-map").length > 0) {
                    this.addFloor(imageParams, currentHeight, instructionIndex, nextFloor);
                    clearInterval(checkExist);
                }
            }, 100); // check every 100ms
        }
    }

    /**
     *
     * @param data
     * @param imageParams
     * @param currentHeight
     * @param nextFloor
     */
    addSingleFloorImage(
        data: any,
        imageParams: any,
        currentHeight: number,
        nextFloor: number
    ) {
        const imgHeight: number = 170 * imageParams.ratio;
        this.imageHeader(this.project.floorNames[nextFloor], currentHeight);
        if(!mobile && this.mozilla) {
            this.doc.addImage(data, "PNG", 18, currentHeight + 7, 170, imgHeight);
        } else {
            this.doc.addImage(data.toDataURL(), "PNG", 18, currentHeight + 7, 170, imgHeight);
        }

        currentHeight += imgHeight + 11; // Add size of image

        Emitter.emit(Events.GENERATE_PDF_LOADER, false);
        changePathStroke(this.paths[`floor${ nextFloor }`], 7);

        this.addStepInstructions(currentHeight, this.instructions);
        this.saveDocument((window as any).lang.getString('pdf_fileNameToText', [this.origin.description, this.destination.description]), this);
    }

    /**
     *
     * @param imageParams
     * @param currentHeight
     */
    printSingleFloor(imageParams: any, currentHeight: number) {
        // Take Only one screenshot
        const nextFloor = this.floorsToPrint[this.routeCount];

        // Fit window closest to the paths themselves, make stroke bigger so it is more visible printing
        fitPathsToMap(this.paths[`floor${nextFloor}`], this.routeFacilities[`route${nextFloor}`]);
        changePathStroke(this.paths[`floor${nextFloor}`], 10);
        Emitter.emit(Events.GENERATE_PDF_LOADER, true);

        const checkExist = setInterval(() => {
            // if ($(".spreo-map > div > div > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > div:nth-child(2) > div > div").length > 0) {
                clearInterval(checkExist);

                setTimeout(() => {
                    // GET map image and print it along with the rest of the instructions.
                    const map: any = document.querySelector(".gm-style>div");
                    // Removed black square in the hint bubble in PDF
                    Pdf.hideCloseBtns();

                    /**
                     * We should use html-to-image library only for Mozilla Firefox on PC
                     * to optimize PDF generating.
                     * There is an issue in Firefox with converting images from html
                     * See more https://github.com/niklasvh/html2canvas/issues/2028
                     */
                    if(!mobile && this.mozilla) {
                        htmlToImage.toPng(map)
                            .then( (dataUrl: string) => {
                                this.addSingleFloorImage(
                                    dataUrl,
                                    imageParams,
                                    currentHeight,
                                    nextFloor
                                );

                                Pdf.displayCloseBtns();
                            });
                    } else {
                        (window as any).html2canvas(map, {
                            useCORS: true,
                            logging: false,
                            width: imageParams.width,
                            height: imageParams.height,
                        })
                            .then((canvas: any) => {
                                this.addSingleFloorImage(
                                    canvas,
                                    imageParams,
                                    currentHeight,
                                    nextFloor
                                );

                                Pdf.displayCloseBtns();
                            })
                            .catch((error: any) => {
                                Pdf.displayCloseBtns();
                                throw new Error(error);
                            });
                    }
                }, 3000); // 3 extra second before initializing the print maps
            // }
        }, 100); // check every 100ms
    }

    /**
     *
     * @param withMap
     */
    print(withMap: boolean = true) {
        // Prepare Header with navigation overview
        const currentHeight = this.documentHeader() + 16;

        // Prepare Instructions
        const multipleFloors: boolean = !!(this.origin.floor !== this.destination.floor ||
            (this.intermediateFloors && this.intermediateFloors.length));

        // Print instructions without map
        if (!withMap) {
            const pathText = (window as any).lang.getString('pdf_fileNameToText', [this.origin.description, this.destination.description]);
            this.printWithoutMap(this.instructions, multipleFloors, currentHeight, pathText);
        } else {
            /**
             *  Print instructions with map
             *  Note: Very hard to determine when custom overlay tiles are done loading
             */
            const width: any = $(document).width();
            const height: any = $(document).height();
            const imageParams = {
                width,
                height,
                ratio: height / width,
            };

            if (multipleFloors) {
                this.routeCount = 0;
                this.printMultipleFloors(imageParams, currentHeight);
                return;
            }

            this.printSingleFloor(imageParams, currentHeight);
        }
    }

    /**
     *
     * @param stepInstructions
     * @param multipleFloors
     * @param currentHeight
     * @param title
     */
    printWithoutMap(stepInstructions: any [], multipleFloors: boolean, currentHeight: number, title: string = 'Route') {
        if (multipleFloors) {
            const documentState: any = this.addStepInstructions(currentHeight, stepInstructions);
            this.addStepInstructions(documentState.currentHeight + 15, stepInstructions, documentState.instructionIndex);
        } else {
            this.addStepInstructions(this.startingHeight + 15, stepInstructions);
        }

        this.saveDocument(title, this);
    }
}

export default Pdf;
